import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';

/** Hero / header above-fold: animazioni al mount (nessuno ScrollTrigger). */
export default function useGsapHero(ref, { setup } = {}) {
  const [inView, setInView] = useState(false);
  const setupRef = useRef(setup);
  setupRef.current = setup;

  useEffect(() => {
    const scope = ref.current;
    if (!scope) return undefined;

    const ctx = gsap.context(() => {
      const reveal = scope.querySelectorAll('.gsap-reveal');
      if (reveal.length) {
        gsap.from(reveal, {
          opacity: 0,
          y: 24,
          duration: 0.9,
          stagger: 0.08,
          delay: 0.15,
          ease: 'power3.out',
        });
      }

      const heroSub = scope.querySelector('.hero-sub');
      if (heroSub) {
        gsap.from(heroSub, {
          opacity: 0,
          y: 20,
          duration: 1,
          delay: 0.45,
          ease: 'power3.out',
        });
      }

      const heroStripLine = scope.querySelector('.hero-strip-line');
      if (heroStripLine) {
        gsap.from(heroStripLine, {
          scaleX: 0,
          duration: 1.4,
          delay: 0.55,
          ease: 'power3.out',
          transformOrigin: 'left center',
        });
      }

      const heroLine = scope.querySelector('.gsap-hero-line');
      if (heroLine) {
        gsap.from(heroLine, {
          scaleX: 0,
          duration: 0.6,
          delay: 0.3,
          ease: 'power3.out',
          transformOrigin: 'left center',
        });
      }

      setupRef.current?.(gsap, scope);
    }, scope);

    requestAnimationFrame(() => setInView(true));

    return () => {
      setInView(false);
      ctx.revert();
    };
  }, [ref]);

  return inView;
}
